import Button from 'components/ui/Button';
import Modal from 'components/ui/Modal';
import { Loader2 } from 'lucide-react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeContactFromSegmentRequest } from 'store/segments/segments.action';
import { selectRemoveContactLoading } from 'store/segments/segments.selector';
import { IContact } from 'types/contacts/contacts.types';
import { ISegment } from 'types/segments/segments.types';

interface RemoveContactModalProps {
  isOpen: boolean;
  onClose: () => void;
  segment?: ISegment | null;
  contact?: IContact | null;
}

const RemoveContactModal: React.FC<RemoveContactModalProps> = ({
  isOpen,
  onClose,
  segment,
  contact,
}) => {
  const dispatch = useDispatch();
  const loading = useSelector(selectRemoveContactLoading);

  const handleRemove = () => {
    if (contact?._id && segment?._id) {
      dispatch(removeContactFromSegmentRequest(segment._id, contact._id));
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Remove Contact">
      <p className="text-muted-foreground mb-4">
        Are you sure you want to remove this contact from the segment?
      </p>
      {segment && (
        <div className="mb-4 p-3 bg-muted rounded-lg border border-border">
          <p className="text-sm text-foreground">
            <span className="font-medium">Segment:</span> {segment.name}
          </p>
        </div>
      )}
      {contact && (
        <div className="mb-6 p-3 bg-muted rounded-lg border border-border">
          <p className="text-sm text-foreground">
            <span className="font-medium">Contact:</span> {contact.email}
            {contact.firstName && contact.lastName && (
              <span className="text-muted-foreground">
                {' '}
                ({contact.firstName} {contact.lastName})
              </span>
            )}
          </p>
        </div>
      )}
      <div className="flex justify-end gap-3 pt-4 border-t border-border">
        <Button variant="outline" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={handleRemove}
          disabled={loading}
          className="flex items-center gap-2"
        >
          {loading && <Loader2 className="w-4 h-4 animate-spin" />}
          {loading ? 'Removing...' : 'Remove'}
        </Button>
      </div>
    </Modal>
  );
};

export default RemoveContactModal;
